export default {"src":"/_next/static/media/0xb20116ee399f15647bb1eef9a74f6ef3b58bc951.5f9e8497.svg","height":450,"width":450,"blurWidth":0,"blurHeight":0};